import { Button, ButtonProps } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { gql, useMutation } from "@outschool/ui-apollo";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { useTopNoticeContext } from "@outschool/ui-components-website";
import React from "react";

import {
  ResumeOngoingEnrollmentMutation,
  ResumeOngoingEnrollmentMutationVariables
} from "../../../shared/generated/graphql";
import { usePaymentMethods } from "../../hooks/CurrentUser";
import EnrollmentFragment from "../../queries/EnrollmentFragment";
import { SavePaymentMethodModal } from "../account/SavePaymentMethod";
import {
  EnrolledClassEnrollment,
  EnrolledClassGiftEnrollment
} from "../enrolled/EnrolledClassTypes";

type ResumeButtonProps = ButtonProps & {
  onCardUpdated: () => Promise<void>;
};
function _ResumeButton(
  { onCardUpdated, onClick, ...buttonProps }: ResumeButtonProps,
  ref: React.Ref<any>
) {
  const { t } = useTranslation(
    "client\\components\\enrolling\\ResumeOngoingEnrollment"
  );
  const [isPaymentMethodModalOpen, setIsPaymentMethodModalOpen] =
    React.useState(false);

  const { loading, paymentMethods } = usePaymentMethods();

  const [defaultPaymentMethod] = paymentMethods;
  const onClickHandler = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      if (!loading && defaultPaymentMethod) {
        onCardUpdated();
      } else if (!loading && !defaultPaymentMethod) {
        setIsPaymentMethodModalOpen(true);
      }
      onClick?.(e);
    },
    [
      loading,
      defaultPaymentMethod,
      onCardUpdated,
      setIsPaymentMethodModalOpen,
      onClick
    ]
  );

  return (
    <>
      <Button
        variant="link"
        onClick={onClickHandler}
        ref={ref}
        {...buttonProps}
        disabled={loading}
      >
        {t`Resume subscription`}
      </Button>
      <SavePaymentMethodModal
        open={isPaymentMethodModalOpen}
        onClose={() => setIsPaymentMethodModalOpen(false)}
        onPaymentSaved={onCardUpdated}
      />
    </>
  );
}

const ResumeButton = React.forwardRef(_ResumeButton);

export const resumeOngoingEnrollmentMutation = gql`
  mutation ResumeOngoingEnrollment($enrollmentUid: ID!) {
    resumeOngoingEnrollment(enrollmentUid: $enrollmentUid) {
      ...EnrollmentFragment
    }
  }
  ${EnrollmentFragment}
`;

type ResumeOngoingEnrollmentProps = ButtonProps & {
  enrollment: EnrolledClassEnrollment | EnrolledClassGiftEnrollment;
};
function _ResumeOngoingEnrollment(
  { enrollment, ...buttonProps }: ResumeOngoingEnrollmentProps,
  ref: React.Ref<any>
) {
  const [resumeOngoingEnrollment, { error }] = useMutation<
    ResumeOngoingEnrollmentMutation,
    ResumeOngoingEnrollmentMutationVariables
  >(resumeOngoingEnrollmentMutation);
  const { setTopNotice } = useTopNoticeContext();

  React.useEffect(() => {
    setTopNotice(error?.toString());
  }, [setTopNotice, error]);
  return (
    <ResumeButton
      onCardUpdated={async () => {
        await resumeOngoingEnrollment({
          variables: {
            enrollmentUid: enrollment.uid
          }
        });
      }}
      ref={ref}
      {...buttonProps}
    />
  );
}

export const ResumeOngoingEnrollment = React.forwardRef(
  _ResumeOngoingEnrollment
);
